import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import CustomImage from '../../fragments/custom-image/CustomImage';
import { motion } from 'motion/react';
import Cinemagraph from '../../fragments/cinemagraph/Cinemagraph';
import Button from '../../fragments/button/Button';
import { useVideoLightbox } from '../../context/VideoLightboxContext';

const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { type: 'linear', duration: 0.4, delay: 0.7 },
};

const MediaBlock = ({ image, video, videoMode, index }) => {
  const { open } = useVideoLightbox();
  const isLightbox = videoMode === 'lightbox' && video;

  return (
    <motion.div
      className={`ComponentMedia-image`}
      style={{ overflow: 'clip' }}
      {...fadeIn}
    >
      {isLightbox ? (
        <>
          <CustomImage
            image={image}
            fill={true}
            parallax={true}
            desktopWidth={66}
          />
          <div className="ComponentMedia-overlay dark">
            <Button
              buttonLabel="Watch now"
              icon="play"
              // theme="secondary"
              onClick={() => open(video, image?.sourceUrl)}
            />
          </div>
        </>
      ) : video ? (
        <Cinemagraph
          media={video}
          poster={image}
          // The poster is the LCP element when this block leads the page — the
          // HLS manifest itself can't be prioritised. Same pattern as Hero.jsx.
          fetchPriority={index === 0 ? 'high' : undefined}
          fill={true}
          forceLoad={true}
        />
      ) : (
        <CustomImage image={image} fill={true} parallax={true} />
      )}
    </motion.div>
  );
};

export default function Media({ block, index }) {
  if (!block) return null;

  return (
    <ComponentWrapper className="ComponentMedia">
      <div className="l-grid">
        {block.heading && (
          <div className={`l-grid__col`}>
            <h2 className="ComponentMedia-heading">{block.heading}</h2>
          </div>
        )}
        {(block.image || block.video) && (
          <div className={`l-grid__col l-grid__col--l-9-12`}>
            <MediaBlock
              image={block.image}
              caption={block.caption}
              imageWidth={block.imageWidth}
              video={block.video}
              videoMode={block.videoMode}
              index={index}
            />
          </div>
        )}
      </div>
    </ComponentWrapper>
  );
}
